import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function ellipsify(str = '', len = 4, delimiter = '..') {
  const strLen = str.length
  const limit = len * 2 + delimiter.length

  return strLen >= limit ? str.substring(0, len) + delimiter + str.substring(strLen - len, strLen) : str
}

// Level/Experience utilities
export function calculateLevel(orbs: number): number {
  let level = 1
  let totalRequired = 0
  while (totalRequired <= orbs) {
    level++
    totalRequired = Math.floor(10 * Math.pow(level - 1, 1.5))
    if (totalRequired > orbs) {
      level--
      break
    }
  }
  return level
}

export function calculateNextLevelRequirement(level: number): number {
  return Math.floor(10 * Math.pow(level, 1.5))
}

export function calculateOrbsToNextLevel(currentOrbs: number): number {
  const currentLevel = calculateLevel(currentOrbs)
  const nextLevelReq = calculateNextLevelRequirement(currentLevel)
  return Math.max(0, nextLevelReq - currentOrbs)
}
